import { useState } from "react";
import { Download, Trash2, X } from "lucide-react";
import { jsPDF } from "jspdf";
import { toast } from "sonner";

export default function SampleBoard({ sampleProducts, onRemoveSample, onClearSamples }) {
  const [generating, setGenerating] = useState(false);

  const downloadPdf = () => {
    if (!sampleProducts.length) return;
    setGenerating(true);
    try {
      const pdf = new jsPDF({ unit: "mm", format: "a4" });
      const date = new Intl.DateTimeFormat("it-IT").format(new Date());
      pdf.setFillColor(24, 23, 21);
      pdf.rect(0, 0, 210, 297, "F");
      pdf.setFillColor(247, 244, 238);
      pdf.rect(14, 14, 182, 269, "F");
      pdf.setTextColor(24, 23, 21);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(9);
      pdf.text("STONE IN LOVE / SIL", 24, 30);
      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(8);
      pdf.text(date, 172, 30, { align: "right" });
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(28);
      pdf.text("Tavola campioni", 24, 52);
      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(10);
      pdf.setTextColor(89, 85, 78);
      pdf.text("Una selezione di Travertino Romano per il tuo progetto.", 24, 62);
      pdf.setDrawColor(164, 85, 50);
      pdf.line(24, 72, 186, 72);
      let y = 91;
      sampleProducts.forEach((product, index) => {
        if (y > 252) {
          pdf.addPage();
          y = 30;
        }
        pdf.setFillColor(164, 85, 50);
        pdf.rect(24, y - 7, 8, 8, "F");
        pdf.setTextColor(247, 244, 238);
        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(7);
        pdf.text(String(index + 1).padStart(2, "0"), 28, y - 1.5, { align: "center" });
        pdf.setTextColor(24, 23, 21);
        pdf.setFontSize(16);
        pdf.text(product.title, 40, y);
        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(8);
        pdf.setTextColor(89, 85, 78);
        pdf.text(`${product.code} · ${product.collection} · ${product.size}`, 40, y + 9);
        pdf.text(`${product.finish} · ${product.price} ${product.unit}`, 40, y + 17);
        pdf.setDrawColor(221, 213, 199);
        pdf.line(24, y + 27, 186, y + 27);
        y += 40;
      });
      pdf.setTextColor(89, 85, 78);
      pdf.setFontSize(8);
      pdf.text("Prezzi indicativi. Disponibilità, formato e finitura vengono verificati con SIL.", 24, 270);
      pdf.save("stoneinlove-tavola-campioni.pdf");
      toast.success("La tavola PDF è pronta da stampare");
    } finally {
      setGenerating(false);
    }
  };

  return (
    <section className="sample-board-section reveal" id="campionario" data-testid="sample-board">
      <div className="site-container sample-board-shell">
        <div className="sample-board-top"><div><span className="eyebrow">Campionario SIL / PDF</span><h2>La tua selezione<br /><i>pronta da condividere.</i></h2></div><p>Raccogli le materie che vuoi discutere e scarica una tavola A4 ordinata per il tuo studio o il tuo cliente.</p></div>
        {sampleProducts.length ? <div className="sample-board-content"><div className="sample-board-grid">{sampleProducts.map((product) => <article className="sample-board-item" key={product.id} data-testid={`sample-board-item-${product.id}`}><img src={product.image} alt="" /><div><span className="product-meta">{product.code} · {product.collection}</span><h3>{product.title}</h3><p>{product.finish} · {product.price} {product.unit}</p></div><button className="sample-board-remove" type="button" onClick={() => onRemoveSample(product.id)} aria-label={`Rimuovi ${product.title} dal campionario`} data-testid={`sample-board-remove-${product.id}`}><X size={15} /></button></article>)}</div><div className="sample-board-actions"><span>{sampleProducts.length.toString().padStart(2, "0")} materiali selezionati</span><div><button className="text-link" type="button" onClick={onClearSamples} data-testid="sample-board-clear"><Trash2 size={15} /> Svuota</button><button className="button button-dark" type="button" onClick={downloadPdf} disabled={generating} data-testid="sample-board-download"><Download size={15} /> {generating ? "Creo PDF…" : "Scarica tavola PDF"}</button></div></div></div> : <div className="sample-board-empty" data-testid="sample-board-empty"><span>01</span><p>Apri una scheda materiale e aggiungi i campioni che vuoi portare al tavolo.</p></div>}
      </div>
    </section>
  );
}
